import { FilePlus } from '@lucide/vue';
import type { CommandFactory } from './commands';
import { appLocationCommand } from './appCommand';

/**
 * Write's app-wide palette entry (I-2348): a new document. Write's document
 * view creates it for `?new=document`; the ribbon's commands and the recent
 * documents join the palette while the editor is open (frontend/write).
 */
export const writeCommands: CommandFactory = ({ router, t, appLabel: write }) => [
  appLocationCommand(router, {
    id: 'write.newDocument',
    app: 'write',
    group: write,
    label: `${write}: ${t('write.workspace.newDocument')}`,
    href: '/write?new=document',
    icon: FilePlus,
    keywords: ['write', 'dokument', 'document', 'text', 'brief', 'neu', 'new'],
  }),
];
